module.exports = __webpack_public_path__ + "d0d33dadc0fa569495bb96601deba7af.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/logos/wr-favicon-white.png
// module id = 520
// module chunks = 0